export const MAX_DURATION_SECONDS = 43_200;
export const MAX_DAY_SECONDS = 86_400;

export const MANIFEST_TYPE = {
  DYNAMIC: 'dynamic',
  STATIC: 'static',
} as const;
